/**
 * Адрес сервера.
 * <p>
 * В браузере пусто — запросы идут относительными путями на тот же домен,
 * откуда загружена страница. В Android-приложении страница загружается
 * из самого APK (origin вида https://localhost), поэтому относительный путь
 * ушёл бы в никуда: там адрес задаётся при сборке через VITE_API_BASE.
 */
export const API_BASE: string = (import.meta.env.VITE_API_BASE ?? '').replace(/\/$/, '');

/** Адрес WebSocket выводится из того же значения, чтобы не задавать его дважды. */
export function websocketUrl(): string {
  if (API_BASE) {
    return API_BASE.replace(/^http/, 'ws') + '/ws';
  }
  const scheme = location.protocol === 'https:' ? 'wss' : 'ws';
  return `${scheme}://${location.host}/ws`;
}

/** Приложение внутри нативной оболочки — тут отличается поведение пушей и клавиатуры. */
export const isNativeApp: boolean = API_BASE !== '';
